import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastSelectField } from 'src/components/mui-overrides/SelectTextField';
import { THeatingType } from '@brickwise/asset-validation/dist/schema/enums';

interface Props {
  disabled?: boolean;
}

export const HeatingTypeSelector: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext();

  return (
    <DefaultFastSelectField
      disabled={disabled}
      label={t('dashboard.assets.addedit.main.energydemand.heatingType.label')}
      fieldName="propertyDetails.heatingType"
      formik={formik}
      options={[
        {
          value: THeatingType.oil,
          label: t('general.heatingtype.oil'),
        },
        {
          value: THeatingType.naturalGas,
          label: t('general.heatingtype.naturalgas'),
        },
        {
          value: THeatingType.district,
          label: t('general.heatingtype.district'),
        },
        {
          value: THeatingType.central,
          label: t('general.heatingtype.central'),
        },
        {
          value: THeatingType.woodPellet,
          label: t('general.heatingtype.woodpellet'),
        },
        {
          value: THeatingType.electric,
          label: t('general.heatingtype.electric'),
        },
        {
          value: THeatingType.floorCentral,
          label: t('general.heatingtype.floorcentral'),
        },
        {
          value: THeatingType.solar,
          label: t('general.heatingtype.solar'),
        },
        {
          value: THeatingType.heatpump,
          label: t('general.heatingtype.heatpump'),
        },
      ]}
    />
  );
};
